import { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component'
import ExpandedComponent from './ExpandedComponent'
import tableCustomStyles from './TableCustomeStyle'
import CustomPagination from '../CustomPagination/CustomPagination'
import './style.css'
import RotatingLinesLoader from '../Loaders/RotatingLinesLoader'

function ReactExpandableTable({
    isLoading,
    data,
    mobileColumns,
    removePagination,
    pageCount,
    activePage,
    rowPerPages,
    totaldata,
    handleRowsPerPage,
    handlePageClick,
    currentRow: controlledCurrentRow,
    setCurrentRow: controlledSetCurrentRow,
    filteredData,
    isSelectSingleRow,
    handleOnRowClicked,
    expandableComponent,
    isSelectableRows,
    handleSelectedRowsChange,
    handleColumnSort,
    handleOnRowDoubleClicked,
    selectableRowSelected,
    conditionalRowStyles,
    gridBorders = false,
}) {
    // Internal state as fallback
    const [internalCurrentRow, setInternalCurrentRow] = useState(null);

    // Prefer controlled props, fallback to internal state
    const currentRow = controlledCurrentRow ?? internalCurrentRow;
    const setCurrentRow = controlledSetCurrentRow ?? setInternalCurrentRow;

    const [toggledClearRows, setToggleClearRows] = useState(false);
    const handleClearRows = () => {
        setToggleClearRows(!toggledClearRows);
    };

    useEffect(() => {
        handleClearRows();
    }, [activePage, rowPerPages, filteredData, data]);

    return (
        <div>
            <DataTable
                className="table-custom-border"
                selectableRowsSingle={isSelectSingleRow}
                onSelectedRowsChange={handleSelectedRowsChange}
                selectableRows={isSelectableRows}
                customStyles={tableCustomStyles(isSelectableRows, false, gridBorders)}
                columns={mobileColumns}
                data={data}
                sortServer
                onSort={handleColumnSort}
                expandableRowExpanded={(row) => row === currentRow}
                onRowExpandToggled={(bool, row) => setCurrentRow(row)}
                expandableRows
                progressPending={isLoading}
                persistTableHead
                expandableRowsComponent={
                    expandableComponent || ExpandedComponent
                }
                pagination={removePagination ? false : true}
                paginationServer
                progressComponent={<RotatingLinesLoader />}
                paginationComponent={() => (
                    <CustomPagination
                        handleRowsPerPage={handleRowsPerPage}
                        handlePageClick={handlePageClick}
                        pageCount={pageCount}
                        rowPerPages={rowPerPages}
                        activePage={activePage}
                        totalData={totaldata}
                    />
                )}
                onRowClicked={handleOnRowClicked}
                onRowDoubleClicked={handleOnRowDoubleClicked}
                selectableRowSelected={selectableRowSelected}
                conditionalRowStyles={conditionalRowStyles}
            />
        </div>
    );
}

export default ReactExpandableTable
